/*
 * Simplified and unified sidebar-group CSS:
 * - Combined cursor and chevron logic for [collapsible] and :not([collapsible])
 * - Grouped hover/focus/active state rules
 * - Clarified collapsed mode label/chevron hiding
 */

@layer refine.base {
  :host {
    display: block;
    width: 100%;
  }

  :host([sidebar-bottom-nav]) {
    display: none;
  }

  .group {
    display: block;
  }

  .group-header {
    all: unset;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-height: var(--size-6);
    padding: var(--size-1) var(--size-2);
    margin-bottom: var(--size-2);
    color: inherit;
    user-select: none;
    outline: none;
    border-radius: var(--rounded-lg);
    transition: background var(--transition-fast);
  }

  .group-header::-webkit-details-marker {
    display: none;
  }

  /* Collapsible group: pointer, hover/focus, show chevron */
  :host([collapsible]) .group-header {
    cursor: pointer;
  }

  :host([collapsible]) .group-header:hover {
    background: var(--color-contrast-100);
  }

  :host([collapsible]) .group-header:focus-visible {
    outline: var(--focus-ring);
  }

  /* Non-collapsible group: default cursor, hide chevron */
  :host(:not([collapsible])) .group-header {
    cursor: default;
  }

  :host(:not([collapsible])) .chevron {
    display: none;
  }

  .group-label {
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: var(--text-xs);
    font-weight: var(--font-semibold);
    color: var(--color-contrast-500);
    text-transform: uppercase;
    letter-spacing: 0.06em;
    white-space: nowrap;
    transition: opacity var(--transition-fast);
  }

  .group-icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    color: var(--color-contrast-400);
  }

  .group-icon:empty {
    display: none;
  }

  .chevron {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    color: var(--color-contrast-400);
    transition: var(--_motion-transition, transform var(--transition-normal));
  }

  /* Chevron rotation for open group */
  :host([collapsible]) .group[open] .chevron {
    transform: rotate(90deg);
  }

  .group-items {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: var(--size-2);
    min-width: 0;
  }

  /* Collapsed-sidebar: hide label text and chevron, center icon */
  :host([sidebar-collapsed]) .group-label,
  :host([sidebar-collapsed]) .chevron {
    display: none;
  }

  :host([sidebar-collapsed]) .group-header {
    display: none;
    height: 0;
    min-height: 0;
    padding: 0;
    margin: 0;
  }

  :host([sidebar-collapsed]) .group-badge {
    position: static;
    display: flex;
    visibility: visible;
    width: auto;
    height: auto;
    pointer-events: auto;
    opacity: 1;
  }

  /* Collapsible group closed: hide items */
  :host([collapsible]:not([open])) .group-items {
    display: none;
  }
}
